import ConfirmBannerModal from "./ConfirmBannerModal";

interface TurnOffBannerModalProps {
    show: boolean;
    busy?: boolean;
    /** The Live banner's message, quoted in the body. */
    message: string;
    onCancel: () => void;
    onConfirm: () => void;
}

/** Confirms taking the Live banner down (MPN-2265 D1). Shared with MPN-2266's dashboard controls. */
export default function TurnOffBannerModal({ show, busy, message, onCancel, onConfirm }: TurnOffBannerModalProps) {
    return (
        <ConfirmBannerModal
            show={show}
            busy={busy}
            title="Turn Off Banner"
            body={`"${message}" comes down now and moves to Expired. Clients see the Partner Dashboard with no banner.`}
            actionLabel="Turn Off"
            onCancel={onCancel}
            onConfirm={onConfirm}
        />
    );
}
